/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntent } from "./PartnerIntent";

/**
 * Records which partner referred the user and when
 */
export interface PartnerIntentModel {
  /** The partner identifier */
  partner: PartnerIntent;
  /** ISO 8601 timestamp of when the intent was captured */
  timestamp: string;
  /** External ID */
  external_id?: string | null;
}
